module.exports = __webpack_public_path__ + "img/1.4fbe5682.png";